<template>
  <div class="home1">
    <div class="banner">
      <div class="hero-container" style="width: 100%;">
        <div class="hero-section"
          style="width: 100%; display: flex; align-items: center;  position: relative; width: 100%; height: 100%;">
          <div style="display: flex; justify-content: start; ">
            <img class="header-logo" src="../assets/images/header-logo.svg" />
          </div>
          <div class="header-dec herosection-content" style="">
            <div>
              <div style=" text-align: center; " class="header-main-section">
                <h2 class="header-main-title">Home Services, Personalized and <br /> Automated!</h2>
              </div>
              <div style=" text-align: center; " class="header-section-title">
                <h2 class="header-title">Founded in Richmond, Virginia</h2>
                <div class="header-subtitle"><span class="header-span" style="font-weight: 100">Trusted by</span>
                  Richmond Homeowners</div>
              </div>
              <div>
                <h2 class="banner-description">Expanding Nationwide</h2>
              </div>
            </div>
          </div>
          <div class="" style="display: flex; justify-content: end; ">
            <img src="../assets/images/header-harvest.svg" class="header-harvest" />
          </div>
        </div>
        <div class="qr-section qr-section-web">
          <div class="qr-box">
            <img src="../assets/images/app-store-badge.svg" alt="App Store QR" class="qr-img" />
            <div>
              <a href="https://apps.apple.com/in/app/nestease/id1539350208" target="_blank">
                <img src="../assets/images/qr-ios.svg" alt="App Store Badge" class="store-badge" />
              </a>
            </div>
          </div>
          <div class="qr-box">
            <img src="../assets/images/play-store-badge.svg" alt="Google Play QR" class="qr-img" />
            <div>
              <a href="https://play.google.com/store/apps/details?id=com.nestease.customer" target="_blank">

                <img src="../assets/images/qr-android.svg" alt="Google Play Badge" class="store-badge" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="outdoor-service outdoor-service-mob">
      <div class="outdoor-service-box container">
        <div class="outdoor-service-label">
          <span class="left"></span> OUTDOOR SERVICES <span class="right"></span>
        </div>
        <div v-if="loading" class="outdoor-service-grid">
          <div v-for="n in 6" :key="n" class="skeleton-card">
            <div class="skeleton skeleton-icon"></div>
            <div class="skeleton-content">
              <div class="skeleton skeleton-title"></div>
              <div class="skeleton skeleton-desc"></div>
            </div>
          </div>
        </div>
        <div v-else class="outdoor-service-grid">
          <div v-for="(service, idx) in outdoorServices" :key="service.title" class="outdoor-service-card"
            :class="{ 'disabled-card': !service.is_enable }"
            :style="{ backgroundColor: service.is_enable ? 'white' : '#F8F8F8' }">
            <div class="outdoor-service-icon-bg" v-html="service.icon"></div>
            <div>
              <div class="outdoor-service-title">{{ service.title }}</div>
              <div class="outdoor-service-desc">{{ service.desc }}</div>
            </div>
          </div>
        </div>
        <div class="dropdown-section">
          <template>
            <div class="container-abs">
              <div class="dropdown-container">
                <div class="outdoor-btn">
                  <button @click="toggleDropdown" class="dropdown-btn about-us-btn-green">
                    DOWNLOAD NOW!
                  </button>
                </div>
                <div v-if="isOpen" class="dropdown-menu" @click.stop>
                  <div class="dropdown-menu-content">
                    <a href="https://apps.apple.com/in/app/nestease/id1539350208" target="_blank">
                      <img src="../assets/images/qr-ios.svg" alt="App Store Badge" class="store-badge" />
                    </a>
                    <a href="https://play.google.com/store/apps/details?id=com.nestease.customer" target="_blank">
                      <img src="../assets/images/qr-android.svg" alt="Google Play Badge" class="store-badge" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="indoor-service">
      <div class="indoor-service-box">
        <div class="indoor-service-label">
          <span class="left"></span> INDOOR SERVICES <span class="right"></span>
        </div>
        <div class="indoor-service-grid">
          <div v-for="service in indoorServices.slice(0, 1)" :key="service.title" class="indoor-service-card">
            <div class="indoor-service-icon-bg" :style="{ backgroundImage: `url(${service.icon})` }"></div>
            <div>
              <div class="indoor-service-title">{{ service.title }}</div>
              <div class="indoor-service-desc">{{ service.desc }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="indoor-bottom-note">
        <p>Looking for a service not listed here?</p>
        <div class="about-us-actions">
          <!-- <button class="about-us-btn about-us-btn-green">DOWNLOAD NOW!</button> -->
          <button class="about-us-btn about-us-btn-grey" @click="onContactUs()">CONTACT US</button>
        </div>
      </div>
    </div>
    <div class="container promo-wrapper-container">
      <div class="promo-wrapper">
        <div class="promo-container">
          <!-- Left Section: Phone and Options -->
          <div class="phone-section">
            <div class="phone-mockup-container">
              <img src="../assets/images/android-mockup.svg" alt="Phone with Options" class="phone-img" />
              <div class="options-list inside-phone">
                <h3 class="options-title">Get Personalized Lawn Mowing</h3>
                <p class="options-desc">Choose from the following options, see your price instantly, and change or
                  pause anytime.</p>
                <div class="option-list">
                  <div v-for="option in mowingOptions" :key="option.label" class="option-item">
                    <img :src="option.icon" :alt="option.alt" class="option-icon" />
                    <span class="option-label">{{ option.label }}</span>
                  </div>
                </div>
                <p class="options-desc-title">Trusted by 100+ happy customers.</p>
              </div>
              <!-- <div class="discount-counts">
                <div class="badge-container">
                    <img class="discount-logo" src="../assets/images/discount20.png" alt="Discount" />
                    <span class="percent-text">20</span>
                 </div>
              </div> -->
              <!-- <div class="discount-counts">
                <img class="discount-logo" src="../assets/images/discount20.png" width="206" height="107"></img>
              <h4 class="discount-numbers">20%</h4>
              </div> -->
            </div>
          </div>
          <div class="discount-section">
            <!-- <img src="../assets/images/off.svg" /> -->
            <h1 class="discount-title">10% <b style="font-size: xx-large;">OFF</b></h1>
            <div class="discount-banner-content">
              <div class="discount-text">
                <h2 class="discount-heading">All 2025 Lawn Mowing Services!</h2>
                <p>YOUR NEED. YOUR TIME. YOUR CHOICE</p>
              </div>
            </div>
            <div> <a href="https://apps.apple.com/in/app/nestease/id1539350208" target="_blank">
                <img src="../assets/images/qr-ios.svg" alt="App Store Badge" class="store-badge" />
              </a>
              <a href="https://play.google.com/store/apps/details?id=com.nestease.customer" target="_blank">
                <img src="../assets/images/qr-android.svg" alt="Google Play Badge" class="store-badge" />
              </a>
            </div>
          </div>
          <div class="qr-section qr-section-mobile">
            <div class="qr-box">
              <img src="../assets/images/app-store-badge.svg" alt="App Store QR" class="qr-img" />
              <div>
                <a href="https://apps.apple.com/in/app/nestease/id1539350208" target="_blank">

                  <img src="../assets/images/qr-ios.svg" alt="App Store Badge" class="store-badge" />
                </a>
                <h2 class="google-map-apple-label">Download the apple app</h2>
              </div>
            </div>
            <div class="qr-box">
              <img src="../assets/images/play-store-badge.svg" alt="Google Play QR" class="qr-img" />
              <div>
                <a href="https://play.google.com/store/apps/details?id=com.nestease.customer" target="_blank">

                  <img src="../assets/images/qr-android.svg" alt="Google Play Badge" class="store-badge" />
                </a>
                <h2 class="google-map-label">Download the google app</h2>
              </div>
            </div>
            <div class="discount-text" style="margin-top: 20px;">
              <h2 class="discount-title-mobile">10% <b style="font-size: 35px;">OFF</b></h2>
            </div>
          </div>
        </div>
        <!-- Discount Banner -->
        <div class="discount-banner">
          <!-- <img class="discount-logo-mobile" src="../assets/images/discount.svg" width="206" height="107" /> -->

          <div class="discount-banner-content discount-banner-content-mob">
            <div class="discount-text">
              <h2 class="discount-sub-heading">All 2025 Lawn Mowing Services!</h2>
              <p>YOUR NEED. YOUR TIME. YOUR CHOICE</p>
            </div>
          </div>
          <div class="discount-banner-content discount-banner-content-web">
            <div class="discount-text">
              <!-- <h2>Additionally, gain $20 if you sign up</h2> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="about-us container">
      <div class="about-us-container">
        <div class="about-us-image">
          <!-- <div class="about-us-dots"></div> -->
          <img src="../assets/images/about-house.svg" alt="House" />
        </div>
        <div class="about-us-content">
          <div class="about-us-label">
            <span class="left"></span>&nbsp;&nbsp;ABOUT US&nbsp;&nbsp;<span class="right"></span>
          </div>
          <h2 class="about-us-title">Redefining Home Services with Technology, Trust, and Flexibility</h2>
          <p class="about-us-desc">
            We are transforming how homeowners manage services like lawn mowing, house cleaning, and more. We're not
            just making it easier—we're changing the game with real-time updates, automated payments, flexible
            scheduling, and reliable in-house crews. Designed for today's homeowner, nestease delivers a modern,
            seamless home care experience built on transparency, control, and trust.
          </p>
          <div class="about-us-stats">
            <div class="about-us-stat">
              <div class="about-us-stat-value">750+</div>
              <div class="about-us-stat-label">Services Done</div>
            </div>
            <div class="about-us-stat">
              <div class="about-us-stat-value">150+</div>
              <div class="about-us-stat-label">Happy Customers</div>
            </div>
            <div class="about-us-stat">
              <div class="about-us-stat-value">50+</div>
              <div class="about-us-stat-label">Clients Reviews</div>
            </div>
          </div>
          <div class="about-us-actions">
            <!-- <button class="about-us-btn about-us-btn-green">DOWNLOAD NOW!</button> -->
            <button class="about-us-btn about-us-btn-grey" @click="onContactUs()">CONTACT US</button>
          </div>
        </div>
      </div>
    </div>
    <div class="our-service">
      <div class="our-service-container container">
        <div class="our-service-content">
          <div class="our-service-label">
            <span class="left"></span>&nbsp;&nbsp; OUR SERVICES &nbsp;&nbsp;<span class="right"></span>
          </div>
          <h2 class="our-service-title">Home Services, Simplified</h2>
          <p class="our-service-desc">
            Nestease makes it easy to manage your home with flexible plans, instant pricing, no contracts, and our
            trusted in-house crew. Personalized and automated—just the way it should be.
          </p>
          <div class="our-service-actions">
            <!-- <button class="our-service-btn our-service-btn-green">DOWNLOAD NOW!</button> -->
            <button class="our-service-btn our-service-btn-grey" @click="onContactUs()">CONTACT US</button>
          </div>
        </div>
        <div class="our-service-image-wrapper">
          <!-- <div class="our-service-dots"></div> -->
          <img class="our-service-image" src="../assets/images/our-service-house.svg" alt="Service House" />
        </div>
      </div>
    </div>
    <div class="image-carousel-section" @touchstart="onTouchStart" @touchmove="onTouchMove" @touchend="onTouchEnd">
      <div class="carousel-inner">
        <div v-for="(testimonial, idx) in testimonials" :key="'slide-' + idx"
          :class="['carousel-item', { active: idx === currentIndex }]">
          <img :src="testimonial.img" class="w-100 banner-img" :alt="'Testimonial image ' + (idx + 1)" />
          <div class="carousel-caption">
            <img src="../assets/svg/comma.svg" />
            <div class="testimonial-carousel-text">{{ testimonial.text }}</div>
          </div>
        </div>
      </div>
      <div class="carousel-indicators">
        <button v-for="(testimonial, idx) in testimonials" :key="'indicator-' + idx"
          :class="{ active: idx === currentIndex }" @click="goToSlide(idx)" aria-label="'Slide ' + (idx + 1)"></button>
      </div>
    </div>
    <div class="testimonial">
      <div class="testimonial-scroll-section">
        <div class="testimonial-scroll-header-row container">
          <div class="testimonial-scroll-header-center">
            <div class="testimonial-scroll-label">
              <span class="left"></span>&nbsp;&nbsp; TESTIMONIALS &nbsp;&nbsp;<span class="right"></span>
            </div>
            <div class="testimonial-subsection">
              <h2 class="testimonial-scroll-title">What Customers Say About Us</h2>
              <h2 class="testimonial-scroll-title" style="padding-top: 10px;">– The Themes</h2>
            </div>
          </div>
          <div class="testimonial-scroll-arrows">
            <button class="arrow-btn left" @click="scrollTestimonials('left')">
              <img src="../assets/images/black-arrow.svg" />
            </button>
            <button class="arrow-btn right" @click="scrollTestimonials('right')">
              <img src="../assets/images/white-arrow.svg" />
            </button>
          </div>
        </div>
        <div class="testimonial-scroll-cards" ref="testimonialScroll">
          <div v-for="(testimonial, idx) in testimonials" :key="'scroll-card-' + idx" class="testimonial-scroll-card">
            <div class="testimonial-scroll-stars">
              <img src="../assets/images/star.svg" /> <img src="../assets/images/star.svg" />
              <img src="../assets/images/star.svg" />
              <img src="../assets/images/star.svg" />
              <img src="../assets/images/star.svg" />
            </div>
            <div v-if="testimonial.title" class="testimonial-scroll-title-card"><em>{{ testimonial.title }}</em></div>
            <div class="testimonial-scroll-text">{{ testimonial.text }}</div>
            <div class="testimonial-scroll-author">
              <span class="testimonial-scroll-avatar"></span>
              <span class="testimonial-author">{{ testimonial.author }}</span>
              <img class="testimonial-scroll-quote" src="../assets/images/quote.svg" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="how-nestease-works-section ">
      <div class="testimonial-scroll-header-center container">
        <div class=" how-nestease-works-section-label"><span class="left"></span>&nbsp;&nbsp;EXPERIENCE&nbsp;&nbsp;<span
            class="right"></span>
        </div>
        <h2 class="how-nestease-works-section-title">How nestease Works</h2>
        <div class="how-nestease-works-flex">
          <div class="how-nestease-works-media" style="position: relative;">
            <video src="../assets/video/homeScreen.mp4" muted controls
              poster="../assets/images/Sign-Up-Video 1.svg" class="how-nestease-works-video" width="360"></video>
            <!-- <img class="mobile-img" src="../assets/images/home/mobile.svg" /> -->
          </div>
          <div class="how-nestease-works-step-list">
            <div v-for="(step, index) in steps" :key="index" class="how-nestease-works-step">
              <span class="step-number">{{ step.number }}</span>
              <div>
                <b>{{ step.title }}</b>
                <div class="step-desc">{{ step.description }}</div>
              </div>
            </div>
            <div style="display: flex; flex-direction: row; gap: 10px;">
              <a href="https://apps.apple.com/in/app/nestease/id1539350208" target="_blank">
                <img src="../assets/images/qr-ios.svg" alt="App Store Badge" class="store-badge" />
              </a>
              <a href="https://play.google.com/store/apps/details?id=com.nestease.customer" target="_blank">
                <img src="../assets/images/qr-android.svg" alt="Google Play Badge" class="store-badge" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="why-nestease-section">
      <div class="why-nestease-container">
        <div class="why-nestease-header">
          <div class="why-nestease-label">
            <span class="left"></span>&nbsp;&nbsp; BENEFITS &nbsp;&nbsp;<span class="right"></span>
          </div>
          <h2 class="why-nestease-title">Why nestease?</h2>
          <div class="why-nestease-subsection">
            <p class="why-nestease-desc">
              We empower customers to select customizable and flexible home services<br>
              through our team of local in-house experts.
            </p>
          </div>
        </div>
        <div class="why-nestease-benefits">
          <div v-for="benefit in benefits" :key="benefit.title" class="benefit-item">
            <img :src="benefit.icon" :alt="benefit.alt" class="benefit-icon" />
            <div>
              <div class="benefit-title">{{ benefit.title }}</div>
              <div class="benefit-desc">{{ benefit.desc }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="patent-section">
      <div class="patent-container">
        <h2 class="patent-title">Patent</h2>
        <div class="patent-content" style="display: flex; justify-content: center; align-items: center;">
          <p class="patent-desc" style="padding: 0 20px">
            Our Product and Technology are protected under Patent Pending status,
            showcasing our commitment to innovation.
          </p>
        </div>
      </div>
    </div>
    <div class="startup-incubator-section">
      <img src="../assets/images/startup-icon.svg" alt="StartUp Virginia Logo" class="startup-incubator-logo" />
      <h2 class="startup-incubator-title">
        We are a proud member of StartUp Virginia Incubator
      </h2>
      <a href="https://startupvirginia.org/" target="_blank" class="startup-incubator-btn">
        Visit Site
      </a>
    </div>
    <div class="promo-banner-container">
      <div class="promo-banner">
        <div class="promo-content">
          <h1 class="promo-banner-title">10% Off All 2025 Lawn Mowing Services</h1>
          <p class="tagline">YOUR NEED. YOUR TIME. YOUR CHOICE</p>
          <p class="service-decs">Service just 2 clicks away</p>
          <p class="service-decs">Download the app now to lock in your discount.</p>
          <div class="app-buttons">
            <img src="../assets/images/apple-store-ligth.svg" alt="Download on App Store" />
            <img src="../assets/images/playstore-ligth.svg" alt="Get it on Google Play" />
          </div>
        </div>
        <div class="phone-mockup">
          <img src="../assets/images/splash-mockup.svg" alt="Phone Mockup" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { db } from '../firebase/config';
import {
  collection,
  getDocs,
  doc,
  getDoc,
} from 'firebase/firestore';
import slide1 from '../assets/images/home/carousel-img/slide1.jpg';
import slide2 from '../assets/images/home/carousel-img/slide2.jpg';
import slide3 from '../assets/images/home/carousel-img/slide3.jpg';
import slide4 from '../assets/images/home/carousel-img/slide4.jpg';

export default {
  data() {
    return {
      outdoorServices: [],
      benefits: [
        {
          title: 'No Contracts',
          desc: 'Request services as needed, no long-term commitment.',
          icon: require('../assets/images/no-contracts.svg'),
          alt: 'No Contracts'
        },
        {
          title: 'In-House Experts',
          desc: 'Consistent, high-quality service from local professionals.',
          icon: require('../assets/images/in-house-experts.svg'),
          alt: 'In-House Experts'
        },
        {
          title: 'Flexibility & Convenience',
          desc: 'Choose services, pricing, and schedules. Pause, switch, or cancel anytime.',
          icon: require('../assets/images/flexibility.svg'),
          alt: 'Flexibility & Convenience'
        },
        {
          title: 'Real-Time Updates',
          desc: 'Stay informed with live tracking, payments, and messaging.',
          icon: require('../assets/images/real-time-updates.svg'),
          alt: 'Real-Time Updates'
        },
        {
          title: 'Ease of Use',
          desc: 'Simple, user-friendly app for a seamless experience.',
          icon: require('../assets/images/ease-of-use.svg'),
          alt: 'Ease of Use'
        }
      ],
      mowingOptions: [
        {
          label: 'Weekly',
          icon: require('../assets/images/mowingimg/weekly.svg'),
          alt: 'Weekly',
        },
        {
          label: 'Every 2 Weeks',
          icon: require('../assets/images/mowingimg/week2.svg'),
          alt: 'Every 2 Weeks',
        },
        {
          label: 'Every 3 Weeks',
          icon: require('../assets/images/mowingimg/week3.svg'),
          alt: 'Every 3 Weeks',
        },
        {
          label: 'Every 4 Weeks',
          icon: require('../assets/images/mowingimg/week4.svg'),
          alt: 'Every 4 Weeks',
        },
        {
          label: 'On Demand Week',
          icon: require('../assets/images/clock.svg'),
          alt: 'On Demand Week',
        },
        {
          label: 'On Demand Day',
          icon: require('../assets/images/calander.svg'),
          alt: 'On Demand Day',
        },
      ],
      indoorServices: [
        {
          title: 'House Cleaning',
          desc: 'Coming This Fall',
          icon: require('../assets/images/house-cleaning.svg'),
        },
        {
          title: 'Snow Removal',
          desc: 'Coming This Winter',
          icon: require('../assets/images/snow-removal.svg'),
        },
      ],
      testimonials: [
        {
          title: "Flexible Scheduling",
          text: "The app is so easy to use. I love being able to pause and change schedules without calling anyone.",
          img: slide1,
          author:'Customer, Glen Allen'
        },
        {
          title: "Personalized Care",
          text: "Very impressed with the quality and how personalized the crew's work was. They followed every note!",
          img: slide2,
          author:'Customer, Midlothian'
        },
        {
          title: "Transparent & Reliable",
          text: "No hassle, no upselling—just straightforward service with real-time updates. Highly recommend.",
          img: slide3,
          author:'Customer, Short Pump'
        },
        {
          title: "Trusted Experience",
          text: "I’ve used a few other services before, but this is by far the most professional and smoothest experience.",
          img: slide4,
          author:'Customer, Richmond'
        },
        {
          title: "Quality Work",
          text: "Crew was great, clean, and respectful. The trimming and mulching made my yard look brand new.",
          img: slide4,
          author:'Customer, Henrico'
        },
        {
          title: "No Upfront Payment",
          text: "Tried it once, ended up setting up every-2-week mowing. Love that I only pay after the job is done!",
          img: slide4,
          author:'Customer, Chesterfield'
        },
        {
          title: "Word-of-Mouth Favorite",
          text: "I found them through a neighbor and now I’ve referred three more families. Awesome service.",
          img: slide4,
          author:'Customer, Moseley '
        },
      ],
      steps: [
        {
          number: 'STEP 1',
          title: 'Verify Your Address',
          description: 'Confirm your location for easy service availability.'
        },
        {
          number: 'STEP 2',
          title: 'Select Service Options',
          description: 'Choose from flexible options and view clear pricing upfront.'
        },
        {
          number: 'STEP 3',
          title: 'Pause, Switch, or Cancel As Needed',
          description: 'Change your preferences whenever needed for full control.'
        },
        {
          number: 'STEP 4',
          title: 'Done!',
          description: 'Relax while our in-house experts handle your request.'
        }
      ],
      currentIndex: 0,
      touchStartX: 0,
      touchEndX: 0,
      myCollectionData: [],
      loading: true,
      error: null,
      isOpen: false,
    };
  },
  mounted() {
    this.loading = true;
    this.fetchOutdoorServices();
  },
  watch: {
    outdoorServices: {
      handler(newVal) {
        // console.log('outdoorServices changed:', newVal);
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    scrollTestimonials(direction) {
      const container = this.$refs.testimonialScroll;
      if (!container) return;
      const scrollAmount = 350;
      if (direction === 'left') {
        container.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      } else {
        container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      }
    },
    goToSlide(idx) {
      this.currentIndex = idx;
    },
    nextSlide() {
      this.currentIndex = (this.currentIndex + 1) % this.testimonials.length;
    },
    prevSlide() {
      this.currentIndex =
        (this.currentIndex - 1 + this.testimonials.length) % this.testimonials.length;
    },
    onTouchStart(e) {
      this.touchStartX = e.changedTouches[0].screenX;
    },
    onTouchMove(e) {
      this.touchEndX = e.changedTouches[0].screenX;
    },
    onTouchEnd() {
      if (this.touchEndX === 0) return;
      const diff = this.touchEndX - this.touchStartX;
      if (Math.abs(diff) > 50) {
        if (diff < 0) {
          this.nextSlide();
        } else {
          this.prevSlide();
        }
      }
      this.touchStartX = 0;
      this.touchEndX = 0;
    },
    async fetchOutdoorServices() {
      this.loading = true;
      this.error = null;

      try {
        const docSnap = await getDoc(doc(db, 'admin-data', 'getOutdoorServices'));

        if (docSnap.exists()) {
          this.outdoorServices = this.formatServices(docSnap.data().outdoorServices);
        } else {
          const colSnap = await getDocs(collection(db, 'admin-data/getOutdoorServices'));
          this.outdoorServices = this.formatServices(colSnap.docs.map(d => d.data()));
        }
      } catch (err) {
        this.error = this.getFirestoreError(err);
        console.error('Fetch error:', err);
      } finally {
        this.loading = false;
        // console.log("this.outdoorServices >>>", this.outdoorServices)
      }
    },
    formatServices(services) {
      return [{
        id: '',
        title: 'Lawn Mowing',
        desc: '',
        icon: `<svg width="48" height="46" viewBox="0 0 48 46" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.737612 23.8615C2.153 24.9076 3.26069 26.1384 4.18377 27.5538C6.09146 30.4769 7.16838 33.7384 7.99915 37.0923C8.70684 39.8923 9.10684 42.7538 9.38377 45.6461H20.8915C20.8915 41.4615 20.0607 37.523 17.9068 33.8615C15.5992 29.923 12.3068 27.0615 8.33761 24.9384C6.42226 23.9179 4.39964 23.113 2.30684 22.5384C1.72223 22.3846 1.19915 22.323 0.737612 22.9999C0.768382 23.0307 0.460689 23.6461 0.737612 23.8615Z" fill="url(#paint0_linear_8038_236172)"/>
<path d="M5.81579 0.599956C8.15425 1.33842 10.2466 2.69226 12.2773 4.07688C17.8158 7.92303 22.0619 12.9384 25.1389 18.9384C28.4004 25.3384 30.0927 32.1692 30.585 39.3076C30.7389 41.4 30.7696 43.523 30.8619 45.6461H22.2466C22.0927 43.8615 22.0619 42.0153 21.7235 40.2615C20.585 34.0769 17.2927 29.2461 12.2773 25.5538C11.9081 25.2769 11.785 25.0307 11.785 24.6C11.785 21.4923 11.5081 18.3846 10.8927 15.3384C9.87733 10.2923 8.15425 5.61534 4.27733 1.98457C3.9081 1.64611 3.9081 1.1538 4.21579 0.723033C4.4004 0.476879 4.7081 0.353802 4.98502 0.41534C5.2004 0.41534 5.44656 0.476879 5.81579 0.599956Z" fill="url(#paint1_linear_8038_236172)"/>
<path d="M27.5687 20.8769C26.9841 19.7076 26.5533 18.6307 25.9687 17.6461C24.9841 15.9538 23.9379 14.2615 22.8918 12.5999C22.7071 12.323 22.6456 12.1076 22.8302 11.7999C24.6456 8.75379 26.7687 6.01533 29.7841 4.07687C31.5995 2.93841 33.5379 2.29225 35.6918 2.23071C36.1533 2.23071 36.5533 2.26148 36.7995 2.72302C37.0456 3.15379 36.9225 3.52302 36.6764 3.92302C35.1379 6.53841 33.8764 9.30764 32.8302 12.1692C32.3995 13.3692 31.9995 14.6307 31.5995 15.8615C31.5379 16.0153 31.4456 16.1692 31.3533 16.323C30.1225 17.7692 28.8918 19.2153 27.661 20.6307C27.661 20.6615 27.6302 20.7538 27.5687 20.8769Z" fill="url(#paint2_linear_8038_236172)"/>
<path d="M47.1374 28.6923C45.599 31.3077 44.3374 34.0769 43.2913 36.9384C42.8605 38.1384 42.4605 39.4 42.0605 40.6307C42.0605 40.6615 42.0297 40.723 41.999 40.8154C41.7221 41.4615 40.799 43.6769 40.399 45.5846L38.1836 45.7077V45.3077C38.2144 44.7846 38.2451 44.2615 38.2451 43.7692C38.3067 42.3846 38.3682 40.9692 38.4913 39.5846C38.8297 35.8307 39.4451 32.2307 40.4297 28.7538C42.1836 27.6769 44.0913 27.0615 46.1836 27C46.6451 27 47.0451 27.0307 47.2913 27.4615C47.5067 27.8923 47.3836 28.2923 47.1374 28.6923Z" fill="url(#paint3_linear_8038_236172)"/>
<path d="M45.5672 13.2769C44.8287 12.5385 43.9364 12.8154 43.1056 12.9077C37.3518 13.4615 33.1056 16.5077 29.7518 21.0308C29.2902 21.6462 28.6749 22.2615 28.5518 22.9385C28.4287 23.5846 28.8902 24.3231 29.1056 25.0308C30.4902 29.2462 31.3825 33.5539 31.7518 37.9846C31.9672 40.5385 31.9979 43.0923 32.121 45.6462H36.921C37.0133 43.5846 37.0749 41.5231 37.2595 39.4923C37.9364 31.8308 39.8749 24.5077 43.4441 17.6769C43.9979 16.6308 44.6441 15.6154 45.2595 14.6C45.2595 14.6 45.8441 13.6769 45.5672 13.2769Z" fill="url(#paint4_linear_8038_236172)"/>
<defs>
<linearGradient id="paint0_linear_8038_236172" x1="-11.7089" y1="13.8898" x2="31.2798" y2="56.8784" gradientUnits="userSpaceOnUse">
<stop stop-color="#64DD17"/>
<stop offset="1" stop-color="#1F8C02"/>
</linearGradient>
<linearGradient id="paint1_linear_8038_236172" x1="-2.49283" y1="4.67473" x2="40.4958" y2="47.6633" gradientUnits="userSpaceOnUse">
<stop stop-color="#64DD17"/>
<stop offset="1" stop-color="#1F8C02"/>
</linearGradient>
<linearGradient id="paint2_linear_8038_236172" x1="11.309" y1="-9.12806" x2="54.2976" y2="33.8606" gradientUnits="userSpaceOnUse">
<stop stop-color="#64DD17"/>
<stop offset="1" stop-color="#1F8C02"/>
</linearGradient>
<linearGradient id="paint3_linear_8038_236172" x1="4.18053" y1="-2.00003" x2="47.1691" y2="40.9889" gradientUnits="userSpaceOnUse">
<stop stop-color="#64DD17"/>
<stop offset="1" stop-color="#1F8C02"/>
</linearGradient>
<linearGradient id="paint4_linear_8038_236172" x1="5.79147" y1="-3.612" x2="48.7801" y2="39.3769" gradientUnits="userSpaceOnUse">
<stop stop-color="#64DD17"/>
<stop offset="1" stop-color="#1F8C02"/>
</linearGradient>
</defs>
</svg>
`,
        is_enable: true
      }, ...(services || []).map(service => ({
        id: service.id || '',
        title: service.name || service.title || '',
        desc: service.description || service.desc || '',
        icon: service.icon || '',
        is_enable: service.is_enable || ""
      }))];
    },
    getFirestoreError(err) {
      const errors = {
        'permission-denied': 'No access permissions',
        'unavailable': 'Network connection failed',
        'default': 'Failed to load services'
      };
      return errors[err.code] || errors.default;
    },
    onContactUs() {
      this.$router.push({
        name: 'Contact'
      }).catch(err => {
        console.error('Navigation error:', err);
      });
    },
    onDownloadClick() {
      if (navigator.platform.indexOf('Mac') > -1) {
        window.open("https://apps.apple.com/in/app/nestease/id1539350208", "_blank");
      } else {
        window.open("https://play.google.com/store/apps/details?id=com.nestease.customer", "_blank");
      }
    },
    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },
    openDropdown() {
      this.isOpen = true
    },
    closeDropdown() {
      this.isOpen = false
    },
    selectItem(item) {
      this.$emit('selected', item)
      this.closeDropdown()
    }
  },
};
</script>

<style scoped lang="scss">
@use '@/assets/styles/components/home';
@use '@/assets/styles/components/skeleton';
</style>
